<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">

								<md-table>
									<md-table-row>
										<md-table-cell style="width: 40%;">លេខកូដគណនី</md-table-cell>
										<md-table-cell style="width: 5px">:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.hash_id).length > 0">{{client.hash_id}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>ឈ្មោះ</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.name).length > 0">{{client.name}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>ឈ្មោះខ្មែរ</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.name_khmer).length > 0">{{client.name_khmer}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>ថ្ងៃខែឆ្នាំកំណើត</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.dob).length > 0">{{client.dob}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>ភេទ</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span
												v-if="String(client.gender).length > 0">{{config.getGenderKhmer(client.gender)}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>

									<!-- <md-table-row>
										<md-table-cell>ID Card</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell><a :href="config.getImageUrl(client.id_card_url)" target="_blank">Show</a>
										</md-table-cell>
									</md-table-row> -->
								</md-table>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-50">
								<!-- <h3>Client Detail</h3> -->
								<md-table>
									<md-table-row>
										<md-table-cell>មុខរបរ</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.occupation).length > 0">{{client.occupation}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>លេខទូរស័ព្ទ</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>លេខអត្តសញ្ញាណប័ណ្ណ</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.id_card).length > 0">{{client.id_card}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>អាសយដ្ឋាន</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.address).length > 0">{{client.address}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<!-- <md-table-row>
										<md-table-cell>Remark</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.note).length > 0">{{client.note}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row> -->
									<md-table-row>
										<md-table-cell>ថ្ងៃបានបង្កើត</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span
												v-if="String(client.created_date).length > 0">{{config.datelify(client.created_date)}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				client: {
					hash_id: "",
					name: "",
					name_khmer: "",
					phone: "",
					note: "",
					gender: "",
					created_date: ""
				},
			}
		},
		created() {
			this.getClient();
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$store.state.authentication.hash_id).then(data => {
					this.client = data.body.data
					this.loaded = true;
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Profile.vue